import { render } from "./DetailModal.vue?vue&type=template&id=a2e1b2bc&scoped=true"
import script from "./DetailModal.vue?vue&type=script&lang=js"
export * from "./DetailModal.vue?vue&type=script&lang=js"

import "./DetailModal.vue?vue&type=style&index=0&id=a2e1b2bc&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2e1b2bc"]])

export default __exports__